import { api } from "@/api";
import { QueryConfig } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";

export interface VentaItemReporteQuery {
    desde?: string,
    hasta?: string,
    clienteId?: string,
    vendedorId?: string,
    articuloId?: string,
    credito?: string,
}

export type ReporteVentaItem = {
    id: string,
    articuloId: string,
    articuloNombre: string,
    articuloCodigo: string,
    articuloIva: number,
    cantidad: number,
    precioUnitario: number,
    costoUnitario: number,
    total: number,
    utilidad: number,

    fecha: string,
    numeroVenta: number,
    numComprobante: string,
    clienteId: string,
    clienteNombre: string,
    clienteNumDocumento: string,
    vendedorId: string,
    vendedorNombre: string,
    credito: boolean,
}

export interface VentaItemReporteResponse {
    count: number,
    total: number,
    utilidad: number,
    result: ReporteVentaItem[]
}

export async function getVentaItemReporte(query: VentaItemReporteQuery = {}): Promise<VentaItemReporteResponse> {
    await sleep(1000);
    const response = await api.get("reportes/venta_item", { params: removeNullOrEmptyKeys(query) })
    return response.data;
}

export function useGetVentaItemReporteQuery(query: VentaItemReporteQuery = {}, queryConfig: QueryConfig<VentaItemReporteResponse>) {
    return useQuery({
        ...queryConfig,
        queryKey: ["reportes", "venta_item", query],
        queryFn: () => getVentaItemReporte(query)
    })
}